"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Youtube = /*#__PURE__*/function (_Component) {
  _inherits(Youtube, _Component);

  function Youtube(props) {
    var _this;

    _classCallCheck(this, Youtube);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Youtube).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "executeCommand", function (command) {
      return function () {
        if (!_this.frameReady) return;
        var youtubeCommand = JSON.stringify({
          event: 'command',
          func: command
        });

        _this.iframeRef.current.contentWindow.postMessage(youtubeCommand, 'https://www.youtube.com');
      };
    });

    _this.state = {
      iframe: {}
    };
    var _this$props = _this.props,
        loop = _this$props.loop,
        autoplay = _this$props.autoplay,
        url = _this$props.url,
        apiKey = _this$props.apiKey;
    var params = "autoplay=".concat(autoplay, "&loop=").concat(loop, "&enablejsapi=1&iv_load_policy=3&modestbranding=1");
    var videoId = Youtube.extractVideoID(url);
    var getUrl = "https://www.googleapis.com/youtube/v3/videos?part=snippet&id=".concat(videoId, "&key=").concat(apiKey);
    _this.iframeRef = _react2["default"].createRef();
    fetch(getUrl).then(function (responseonse) {
      return responseonse.json();
    }).then(function (response) {
      if (response.items.length === 0) return;
      response = response.items[0].snippet;
      var _response = response,
          title = _response.title;
      var _response$thumbnails$ = response.thumbnails["default"],
          width = _response$thumbnails$.width,
          height = _response$thumbnails$.height;
      var thumbUrl = response.thumbnails["default"].url;
      props.setThumb && props.setThumb(thumbUrl, title);
      var src = "https://www.youtube.com/embed/".concat(videoId, "?").concat(params);

      _this.setState({
        iframe: {
          divStyle: {
            padding: "".concat(100 * height / width, "% 0 0 0")
          },
          src: src
        }
      });
    });
    return _this;
  }

  _createClass(Youtube, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.iframeRef.current.onload = function () {
        return _this2.frameReady = true;
      };
    }
  }, {
    key: "render",
    value: function render() {
      var iframe = this.state.iframe;
      var _this$props2 = this.props,
          className = _this$props2.className,
          id = _this$props2.id;
      this.props.playing ? this.executeCommand('playVideo')() : this.executeCommand('pauseVideo')();
      return _react2["default"].createElement("div", {
        style: iframe.divStyle,
        className: "relative ".concat(className)
      }, _react2["default"].createElement("iframe", {
        ref: this.iframeRef,
        title: id,
        className: "absolute top-0 left-0 w-100 h-100",
        src: iframe.src,
        frameBorder: "0",
        allowFullScreen: true,
        allow: "autoplay"
      }));
    }
  }]);

  return Youtube;
}(_react.Component);

_defineProperty(Youtube, "getThumbUrl", function (url, apiKey) {
  return new Promise(function (resolve, reject) {
    var videoId = Youtube.extractVideoID(url);
    var getUrl = "https://www.googleapis.com/youtube/v3/videos?part=snippet&id=".concat(videoId, "&key=").concat(apiKey);
    fetch(getUrl).then(function (responseonse) {
      return responseonse.json();
    }).then(function (response) {
      if (response.items.length === 0) {
        reject("No video found with URL: ".concat(url, " and apiKey: ").concat(apiKey));
        return;
      }

      response = response.items[0].snippet;
      resolve(response.thumbnails["default"].url);
    });
  });
});

_defineProperty(Youtube, "extractVideoID", function (url) {
  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  var match = url.match(regExp);

  if (match && match[7].length === 11) {
    return match[7];
  }

  console.error('Could not extract youtube video ID');
  return '';
});

Youtube.propTypes = {
  url: _propTypes2["default"].string.isRequired,
  id: _propTypes2["default"].number.isRequired,
  // Unique ID for iframe title
  setThumb: _propTypes2["default"].func,
  className: _propTypes2["default"].string,
  loop: _propTypes2["default"].bool,
  autoplay: _propTypes2["default"].bool,
  width: _propTypes2["default"].number,
  height: _propTypes2["default"].number,
  playing: _propTypes2["default"].bool,
  apiKey: _propTypes2["default"].string.isRequired // API key necessary for youtube requests

};
Youtube.defaultProps = {
  loop: true,
  autoplay: false,
  width: null,
  height: null,
  className: ''
};
exports["default"] = Youtube;